import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Cart, OrderTypes } from '@next/core-lib/cart';
import { FeatureFlagService } from '@next/core-lib/featureflag';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { BreakpointService, BreakpointServiceInjector } from '@next/core-lib/responsive';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { map, Observable, switchMap } from 'rxjs';
import { SearchFavoritesComponent } from 'src/app/product/components/favorites/search-favorites.component';
import { ProductComponent } from 'src/app/product/product.component';
import { ShopFeatureFlags } from 'src/app/shared/shop-feature-flags';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  imports: [CommonModule, ProductComponent, SearchFavoritesComponent, AgrI18nSharedModule, MatIconModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent implements OnInit {
  @Input() cart?: Cart;
  @Input() showAddProductsReminder = false;
  @Input() editable;
  @Input() showFavoritesSearch = true;
  orderTypes = OrderTypes;
  public readonly isDesktopDisplay$ = this.breakpointService.lg$;
  customer$ = this.store.select(UserSelectors.selectCustomer);
  isFavoritesEnabled$: Observable<boolean> = new Observable<boolean>();

  constructor(
    @Inject(BreakpointServiceInjector) readonly breakpointService: BreakpointService,
    private featureFlagService: FeatureFlagService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.isFavoritesEnabled$ = this.customer$.pipe(
      map((selectedCustomer) => selectedCustomer?.shipTos[0]?.salesAreas[0]?.salesOrganization),
      switchMap((salesOrganization) => this.featureFlagService.getFeatureFlagsForSalesArea(salesOrganization)),
      map((featureFlags) => featureFlags.includes(ShopFeatureFlags.enableFavorites)),
    );
  }
}
